/*** IMPORTS FROM imports-loader ***/
var define = false;

/*** IMPORTS FROM imports-loader ***/


'use strict';
const Logger = require('../logger');

const AbstractMessageHandler = require('./abstract_message_handler');

class MessageHandlerEnableButton extends AbstractMessageHandler {

  get MESSAGE_EVENT() {
    return 'enable_button';
  }

  handleMessage(message) {
    Logger.sendLog('enable_button called', { selector: message.data.selector });
    this.window.$(message.data.selector)
      .removeClass('e-btn-disabled');
  }

}

module.exports = MessageHandlerEnableButton;




/*** EXPORTS FROM exports-loader ***/



/** WEBPACK FOOTER **
 ** ./message_handler/enable_button.js
 **/